export const tbwMetadataActionTypes = {
    UPDATE_TBW_META_TITLE: 'UPDATE_TBW_META_TITLE',
    UPDATE_TBW_META_DESC: 'UPDATE_TBW_META_DESC',
    UPDATE_TBW_META_AEMID: 'UPDATE_TBW_META_AEMID',
    UPDATE_TBW_META_DOCID: 'UPDATE_TBW_META_DOCID',
    UPDATE_TBW_ACTIVE_CARDS: 'UPDATE_TBW_ACTIVE_CARDS',
    UPDATE_TBW_TEMPLATE_DATA: 'UPDATE_TBW_TEMPLATE_DATA',
    UPDATE_TBW_HERO_URL: 'UPDATE_TBW_HERO_URL',
    UPDATE_TBW_THUMBNAIL_URL: 'UPDATE_TBW_THUMBNAIL_URL',
    UPDATE_TBW_INTRO_VIDEO_URL: 'UPDATE_TBW_INTRO_VIDEO_URL',
    UPDATE_TBW_COMPLETION_MSG: 'UPDATE_TBW_COMPLETION_MSG',
    UPDATE_TBW_COMPLETION_MEDIA: 'UPDATE_TBW_COMPLETION_MEDIA',
    UPDATE_TBW_TOPICS: 'UPDATE_TBW_TOPICS',
    UPDATE_TBW_TOOLS: 'UPDATE_TBW_TOOLS',
    UPDATE_TBW_TASKS: 'UPDATE_TBW_TASKS',
    UPDATE_TBW_EXPERIENCE_LEVEL: 'UPDATE_TBW_EXPERIENCE_LEVEL',
    UPDATE_TBW_LEARNING_APPROACH: 'UPDATE_TBW_LEARNING_APPROACH',
    UPDATE_TBW_CREATIVE_FIELDS: 'UPDATE_TBW_CREATIVE_FIELDS',
    UPDATE_TOTAL_EXP_LEVELS: 'UPDATE_TOTAL_EXP_LEVELS',
    UPDATE_TOTAL_CREATIVE_FIELDS: 'UPDATE_TOTAL_CREATIVE_FIELDS',
    UPDATE_TOTAL_TASKS: 'UPDATE_TOTAL_TASKS',
    UPDATE_TOTAL_TOOLS: 'UPDATE_TOTAL_TOOLS',
    UPDATE_TOTAL_TOPICS: 'UPDATE_TOTAL_TOPICS',
    UPDATE_TOTAL_META_DATA: 'UPDATE_TOTAL_META_DATA',
    RESET_META_DATA: 'RESET_META_DATA',
    UPDATE_READ_ONLY_MODE: 'UPDATE_READ_ONLY_MODE',
    UPDATE_TBW_META_APP_ID: 'UPDATE_TBW_META_APP_ID',
    UPDATE_TBW_LOCALE: 'UPDATE_TBW_LOCALE',
    UPDATE_TBW_IS_ENGLISH_LOCALE_FLAG: 'UPDATE_TBW_IS_ENGLISH_LOCALE_FLAG',
    UPDATE_TBW_TRANSIENT_ID: 'UPDATE_TBW_TRANSIENT_ID',
    UPDATE_TBW_TEMPLATE_SIZE: 'UPDATE_TBW_TEMPLATE_SIZE',
    UPDATE_TBW_TEMPLATE_NEED_LOC: 'UPDATE_TBW_TEMPLATE_NEED_LOC',
    UPDATE_TBW_IMAGE_CREDIT_TO_AUTHOR: 'UPDATE_TBW_IMAGE_CREDIT_TO_AUTHOR',
    UPDATE_TBW_META_RELATED_CONTENTS: 'UPDATE_TBW_META_RELATED_CONTENTS',
};

export const tbwStarterFileActionTypes = {
    UPDATE_TBW_STARTER_FILE_URL: 'UPDATE_TBW_STARTER_FILE_URL',
    UPDATE_TBW_STARTER_FILE_CONTAINS_TEXT: 'UPDATE_TBW_STARTER_FILE_CONTAINS_TEXT',
    UPDATE_TBW_STARTER_FILE_CREDIT: 'UPDATE_TBW_STARTER_FILE_CREDIT',
};

export const tbwGlobalActionTypes = {
    INITIATE_GLOBAL_SAVE: 'INITIATE_GLOBAL_SAVE',
    INITIATE_GLOBAL_PREVIEW: 'INITIATE_GLOBAL_PREVIEW',
    INITIATE_SUBMIT_UTUT: 'INITIATE_SUBMIT_UTUT',
    INITIATE_DELETE_UTUT: 'INITIATE_DELETE_UTUT',
};

export const tbwSectionDataActionTypes = {
    INJECT_NEW_EMPTY_SECTION: 'INJECT_NEW_EMPTY_SECTION',
    DELETE_EXISTING_SECTION: 'DELETE_EXISTING_SECTION',
    UPDATE_EXISTING_SECTION: 'INJECT_NEW_SECTION',
    MOVE_SECTION_UP: 'MOVE_SECTION_UP',
    MOVE_SECTION_DOWN: 'MOVE_SECTION_DOWN',
    INJECT_NEW_EMPTY_TASK: 'INJECT_NEW_TASK',
    DELETE_EXISTING_TASK: 'DELETE_EXISTING_TASK',
    UPDATE_EXISTING_TASK: 'UPDATE_EXISTING_TASK',
    MOVE_TASK_UP: 'MOVE_TASK_UP',
    MOVE_TASK_DOWN: 'MOVE_TASK_DOWN',
    UPDATE_TASK_IMAGES: 'UPDATE_TASK_IMAGES',
    UPDATE_TASK_SUCCESSCONDITION: 'UPDATE_TASK_SUCCESSCONDITION',
    UPDATE_TOTAL_SECTION_DATA: 'UPDATE_TOTAL_SECTION_DATA',
    RESET_SECTION_DATA: 'RESET_SECTION_DATA',
};

export const tbwDashboardDataActionTypes = {
    UPDATE_DASHBOARD_DATA: 'UPDATE_DASHBOARD_DATA',
};
